"use client";

import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const LOCATIONS = [
  {
    id: "mcallen",
    label: "MCALLEN",
    url: "https://dashboard.elitepokerlounge.com/",
  },
  {
    id: "brownsville",
    label: "BROWNSVILLE",
    url: "https://dashboard.brownsville.elitepokerlounge.com/",
  },
];

const getCurrentLocationId = () => {
  const host = window.location.hostname.toLowerCase();
  if (
    host.includes("brownsville") ||
    host === "localhost" ||
    host === "127.0.0.1"
  ) {
    return "brownsville";
  }
  return "mcallen";
};

export function LocationSwitcher() {
  const [open, setOpen] = useState(false);
  const [activeId] = useState(getCurrentLocationId);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const activeLocation =
    LOCATIONS.find((loc) => loc.id === activeId) || LOCATIONS[0];

  const handleSelect = (location) => {
    setOpen(false);
    if (location.id === activeId) return;
    window.location.href = location.url;
  };

  return (
    <div ref={containerRef} className="relative shrink-0">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={`flex items-center gap-1.5 rounded-md border bg-white px-3 py-2 text-xs font-semibold uppercase tracking-wider transition shadow-sm ${
          open
            ? "border-yellow-400 bg-yellow-50 text-yellow-700"
            : "border-gray-300 text-yellow-600 hover:border-yellow-400 hover:bg-yellow-50"
        }`}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label="Switch location"
      >
        <span>{activeLocation.label}</span>
        <ChevronDown
          className={`h-3.5 w-3.5 text-gray-500 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div
          role="listbox"
          className="absolute left-0 top-full z-[60] mt-1 min-w-[11rem] overflow-hidden rounded-md border border-gray-200 bg-white py-1 shadow-lg"
        >
          {LOCATIONS.map((location) => {
            const isActive = location.id === activeId;
            return (
              <button
                key={location.id}
                type="button"
                role="option"
                aria-selected={isActive}
                onClick={() => handleSelect(location)}
                className={`block w-full px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider transition ${
                  isActive
                    ? "bg-yellow-50 text-yellow-600"
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
              >
                {location.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
